// /app/frontend/src/components/frugal-v2/components/scheduled/scheduledTranslations.js
// Translations for scheduled charges (50 lines)

export const translations = {
  es: {
    title: "Próximos Meses",
    subtitle: "Cargos programados para meses futuros",
    add: "Agregar Cargo",
    empty: "No hay cargos programados",
    emptyHint: "Agrega cargos que ocurren en meses específicos (ej: impuestos anuales)",
    name: "Nombre",
    amount: "Monto",
    category: "Categoría",
    month: "Mes",
    day: "Día",
    year: "Año",
    yearHint: "Vacío = se repite cada año",
    notes: "Notas",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    confirmDelete: "¿Eliminar este cargo programado?",
    loading: "Cargando...",
    saving: "Guardando...",
    annual: "Anual",
    oneTime: "Una vez",
    months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", 
             "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
  },
  en: {
    title: "Upcoming Months",
    subtitle: "Scheduled charges for future months",
    add: "Add Charge",
    empty: "No scheduled charges",
    emptyHint: "Add charges that occur in specific months (e.g., annual taxes)",
    name: "Name",
    amount: "Amount",
    category: "Category",
    month: "Month",
    day: "Day",
    year: "Year",
    yearHint: "Empty = repeats every year",
    notes: "Notes",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    confirmDelete: "Delete this scheduled charge?",
    loading: "Loading...",
    saving: "Saving...",
    annual: "Annual",
    oneTime: "One-time",
    months: ["January", "February", "March", "April", "May", "June",
             "July", "August", "September", "October", "November", "December"]
  }
};

export const CATEGORIES = [
  "Impuestos", "Seguros", "Vivienda", "Educacion", "Salud",
  "Transporte/Mantenimiento", "Ocasionales", "Suscripciones", "Otros"
];
